// 页面整体状态机
export enum PageState {
  INITIAL = 'initial',           // 初始状态 - 显示tutorial + input-bar(初始)
  GENERATING = 'generating',      // 生成状态 - 显示scene-list + input-bar(发送后)
  EDITING = 'editing',          // 编辑状态 - 显示所有区域 + input-bar(初始)
  ERROR = 'error'               // 错误状态 - 显示scene-list + input-bar(初始)
}

// InputBar子状态
export enum InputBarState {
  COMPOSE = 'compose',          // 初始状态：大输入框，显示配置
  PROCESSING = 'processing',      // 发送后状态：小输入框，隐藏配置
  DISABLED = 'disabled',         // 禁用状态
  EDITING = 'editing'            // 编辑状态
}

// 区域可见性配置
export interface RegionVisibilityConfig {
  display: 'block' | 'none';
  opacity: number;
  pointerEvents: 'auto' | 'none';
  overflow?: 'visible' | 'hidden';
}

// InputBar UI配置
export interface InputBarUIConfig {
  // UI布局
  containerWidth: 'full' | 'compact';      // 34% 或 24%
  containerHeight: 'tall' | 'short';      // 高或矮
  paddingSize: 'large' | 'small';         // pb-4 或 pb-2

  // 输入框状态
  textareaHeight: number;                   // 100px 或 48px
  textareaDisabled: boolean;                // 是否禁用输入
  showScrollbar: boolean;                  // 是否显示滚动条

  // 按钮状态
  buttonIcon: 'send' | 'stop' | 'spinner'; // 发送/停止/加载图标
  buttonDisabled: boolean;                 // 是否禁用按钮
  buttonVisible: boolean;                  // 是否显示按钮

  // 配置区域
  configVisible: boolean;                  // 配置选项是否显示
  configDisabled: boolean;                 // 配置是否禁用
}

// InputBar完整状态配置
export interface InputBarStateConfig {
  state: InputBarState;
  ui: InputBarUIConfig;
}

// 页面状态转换规则
export interface PageStateTransition {
  inputBarState: InputBarState;
  allowedNextStates: PageState[];
  regions: {
    tutorial: 'visible' | 'hidden';
    sceneList: 'visible' | 'hidden' | 'loading';
    resultArea: 'visible' | 'hidden';
  };
  triggers: {
    enter: string;    // 进入状态的触发条件
    exit: string;     // 离开状态的触发条件
  };
}

// 区域可见性完整配置
export interface RegionVisibilityMapping {
  tutorialArea: RegionVisibilityConfig;
  sceneListArea: RegionVisibilityConfig;
  resultArea: RegionVisibilityConfig;
}